import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { List } from 'immutable';
import { forkJoin, Observable, of } from 'rxjs';
import { AuthDataStore } from '../auth-data/auth-data.store';
import { CookieService } from '../browser-manager-data/cookie.service';
import { AccountMigration } from './models/account-migration.model';
import {
  getAccountMigration,
  getCompletedOnboardingData,
  initialState,
} from './onboarding-data.reducer';
import { filter, flatMap, map, take } from 'rxjs/operators';

export const I2G_COMPLETED_ONBOARDING_KEY = 'I2G_COMPLETED_ONBOARDING';

export const NEW_USER_COOKIE = 'createFlag';

@Injectable()
export class OnboardingDataStore {
  accountMigration$: Observable<AccountMigration> = this._store.select(
    getAccountMigration
  );
  completedOnboardingData$: Observable<List<string>> = this._store.select(
    getCompletedOnboardingData
  );

  constructor(
    private _cookieService: CookieService,
    private _store: Store<any>,
    private _authDataStore: AuthDataStore
  ) {}

  getAccountMigration(): Observable<AccountMigration> {
    return this.accountMigration$.pipe(
      filter(
        (accountMigration: AccountMigration) =>
          accountMigration !== initialState.accountMigration
      ),
      take(1)
    );
  }

  isNewUser(): boolean {
    return !!this._cookieService.getCookie(NEW_USER_COOKIE);
  }

  hasCompletedOnboarding(): Observable<boolean> {
    if (this.isNewUser()) {
      return of(false);
    } else {
      return this.accountMigration$.pipe(
        filter((x) => !!x),
        flatMap((accountMigration: AccountMigration) => {
          if (accountMigration.accountVersion === 1) {
            return of(false);
          } else if (accountMigration.isAccountMigrated) {
            return forkJoin(
              this._authDataStore.getUserId(),
              this.getCompletedOnboardingData()
            ).pipe(
              map(
                ([userId, completedOnboardingData]) =>
                  completedOnboardingData.indexOf(userId) > -1
              )
            );
          } else {
            return of(true);
          }
        }),
        take(1)
      );
    }
  }

  getCompletedOnboardingData(): Observable<List<string>> {
    return this.completedOnboardingData$.pipe(take(1));
  }
}
